function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M10 2.5C8.34313 2.5 7 4.06687 7 6C7 7.93281 8.34313 9.5 10 9.5C11.6562 9.5 13 7.93344 13 6C13 4.06687 11.6569 2.5 10 2.5ZM11.25 7.75C11.25 7.88812 11.1381 8 11 8H9C8.86187 8 8.75 7.88812 8.75 7.75V7.25C8.75 7.11188 8.86187 7 9 7H9.5V5.2675L9.48531 5.27719C9.45801 5.29541 9.42738 5.30807 9.39518 5.31445C9.36298 5.32082 9.32984 5.32079 9.29765 5.31434C9.26546 5.3079 9.23486 5.29518 9.20759 5.2769C9.18033 5.25862 9.15694 5.23514 9.13875 5.20781L8.86125 4.79187C8.84303 4.76457 8.83037 4.73394 8.82399 4.70174C8.81762 4.66954 8.81765 4.6364 8.82409 4.60421C8.83054 4.57202 8.84326 4.54142 8.86154 4.51416C8.87982 4.48689 8.9033 4.4635 8.93062 4.44531L9.40969 4.12594C9.53286 4.04381 9.67759 3.99999 9.82563 4H10.25C10.3881 4 10.5 4.11188 10.5 4.25V7H11C11.1381 7 11.25 7.11188 11.25 7.25V7.75ZM19 0H1C0.447812 0 0 0.447812 0 1V11C0 11.5522 0.447812 12 1 12H19C19.5522 12 20 11.5522 20 11V1C20 0.447812 19.5522 0 19 0ZM18.5 8.5C17.3953 8.5 16.5 9.39531 16.5 10.5H3.5C3.5 9.39531 2.60469 8.5 1.5 8.5V3.5C2.60469 3.5 3.5 2.60469 3.5 1.5H16.5C16.5 2.60469 17.3953 3.5 18.5 3.5V8.5Z",
  fill: "white"
});

var SvgDf = function SvgDf(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 20,
    height: 12,
    viewBox: "0 0 20 12",
    fill: "none",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDf, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/DF.73b13770.svg";
export { ForwardRef as ReactComponent };